import { Component, Input, WritableSignal } from '@angular/core';

@Component({
  selector: 'config-field',
  templateUrl: './config-field.component.html',
  styleUrls: ['./config-field.component.scss'],
})
export class ConfigFieldComponent {
  @Input() inputValue!: WritableSignal<string | undefined>;
  @Input() title!: string;
  @Input() name!: string;

  inputValueChange(event: any) {
    this.inputValue.set(event.target.value);
  }

  radioCheckedChanged(type: 'default' | 'custom') {
    if (type === 'default') {
      this.inputValue.set(undefined)
    } else {
      this.inputValue.set('')
    }
  }

  checkboxCheckedChanged(event: any) {
    this.inputValue.set(event.target.checked ? undefined : '');
  }

  useDefaultValue(): boolean {
    return typeof this.inputValue() !== 'string';
  }
}